import { render, staticRenderFns } from "./BrandWorkIcon.vue?vue&type=template&id=13c51a36"
import script from "./BrandWorkIcon.vue?vue&type=script&lang=js"
export * from "./BrandWorkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports